/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Component, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BaseDialogComponent} from "../../../../platform/base/components/base-dialog.component";
import {ShotScoreService} from "../../shot-score.service";
import {TranslateService} from "@ngx-translate/core";

/**
 *
 *
 * @since 0.01
 */
@Component({
	selector: "aigia-update-dialog",
	styleUrls: ["./update-dialog.component.css"],
	templateUrl: "./update-dialog.component.html",
})
export class UpdateListComponent extends BaseDialogComponent implements OnInit {

	get content(): any {
		return this.data.content;
	}

	public scopes = [
		{name: '非公開', value: 0},
		{name: '公開', value: 100},
	];

	public clubs:{name: string, value: number}[];

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		public matDialogRef: MatDialogRef<UpdateListComponent>,
		public shotscore: ShotScoreService,
		public translate: TranslateService
	) {
		super();
		this.clubs = shotscore.clubs;
	}

	public ngOnInit(): void {
		if (!this.data.platform.description) {
			this.data.platform.description = {message: "", club: 0};
		}
	};

	public cancel(): void {
		this.matDialogRef.close(false);
	};

	public onAccept(): void {
		this.matDialogRef.close(true);
	};

}
